import "./App.css";
import LandingRoutes from "./routes/landingRoutes";

function App() {
   return <LandingRoutes />;
}

export default App;
